<template>
  <div id="sidebar-menu" class="mc-side-nav">
    <ul id="side-menu" class="metismenu list-unstyled mc-side-nav__menu-group">
      <template v-for="item in menuItems">
        <!--  eslint-disable-next-line vue/require-v-for-key -->
        <hr v-if="item.isBorder" class="mc-side-nav__horizontal-line" />

        <template v-else>
          <li
            v-if="isMenuShown(item)"
            :id="`SideNav-${item.id}-${item.label.replace(/[.\s]/g, '-')}`"
            :key="item.id"
            class="mc-side-nav__menu-list"
            :class="{ 'mm-active': item.active }"
          >
            <template v-if="item.subItems?.length > 0">
              <a :id="`menu-${item.id}`" aria-expanded="true" class="has-arrow expanded-menu">
                <i :class="`mc-fa ${item.icon}`" />
                <span>{{ $t(item.label) }}</span>
              </a>
              <ul class="mc-side-nav__submenu-group sub-menu">
                <template v-for="subItem in item.subItems">
                  <li
                    v-if="subItem.isHasAccess()"
                    :id="`SideNav-${subItem.id}-${item.label.replace(/[.\s]/g, '-')}`"
                    :key="subItem.id"
                    class="mc-side-nav__submenu-list"
                  >
                    <router-link :to="subItem.link" class="mc-side-nav__list-wrapper">
                      <i :class="`mc-fa ${subItem.icon}`" />
                      <span class="label">{{ $t(subItem.label) }} </span>
                      <McBadge
                        v-if="subItem.badge || subItem.isNewFeature?.(subItem.module_alias)"
                        class="text-uppercase mc-side-nav__badge"
                        variant="danger"
                        size="small"
                        type="pill"
                        :text="$t('global.new')"
                      />
                    </router-link>
                  </li>
                </template>
              </ul>
            </template>
            <template v-else>
              <router-link
                :id="`SideNav-${item.id}-${item.label.replace(/[.\s]/g, '-')}`"
                v-slot="{ isActive, isExactActive }"
                :to="item.link"
                :exact-path="item.isExactPath"
                custom
                class="mc-side-nav__menu-list"
              >
                <a
                  aria-current="page"
                  class="mc-side-nav__list-wrapper"
                  :href="item.link"
                  :class="[
                    isActive && 'router-link-active',
                    isExactActive && 'router-link-exact-active',
                  ]"
                  @click.prevent="goToPage(item)"
                >
                  <i :class="`mc-fa ${item.icon}`" />
                  <!-- TODO: Finish notification badge -->
                  <div
                    v-if="item.hasNotifBadge && false"
                    class="mc-side-nav__notif-badge notif-badge"
                  ></div>

                  <span class="label">{{ $t(item.label) }}</span>
                  <McBadge
                    v-if="item.badge || item.isNewFeature?.(item.module_alias)"
                    class="text-uppercase mc-side-nav__badge"
                    variant="danger"
                    size="small"
                    type="pill"
                    :text="$t('global.new')"
                /></a>
              </router-link>
            </template>
          </li>
        </template>
      </template>
    </ul>
  </div>
</template>

<script>
import MetisMenu from 'metismenujs/dist/metismenujs'
import McBadge from '@/components/McBadge'
import { isTmsMarketingUser } from '@/helpers/tms-access'

import { firstSection, secondSection, thirdSection } from '../../lib/constants/side-menu-items'
import { Helper } from '@/mixin/helper'

export default {
  components: {
    McBadge,
  },
  computed: {
    menuItems() {
      let menu = [...firstSection]

      const hasSecondSection = secondSection.some((item) => {
        return this.isMenuShown(item)
      })

      const hasThirdSection = thirdSection.some((item) => {
        return this.isMenuShown(item)
      })

      if (hasSecondSection) {
        menu.push({ id: 'first-border', isBorder: true })
        secondSection.forEach((item) => {
          menu.push(item)
        })
      }

      if (hasThirdSection) {
        menu.push({ id: 'second-border', isBorder: true })
        thirdSection.forEach((item) => {
          menu.push(item)
        })
      }

      if (Helper.methods.getCompanyId() == 1449) {
        const menuExclude = ['20', '21']
        menu = menu.filter((item) => !menuExclude.includes(item.id))
      }

      menu = this.applyTmsMarketingMenuAccess(menu)

      menu = menu.map((item) => {
        if (item.subItems) {
          item.active = item.subItems.some((subItem) =>
            this.isRouteMatch(subItem.link, this.$route.path)
          )
        }

        return item
      })

      return menu
    },
  },
  mounted() {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu('#side-menu')
  },
  methods: {
    applyTmsMarketingMenuAccess(menu) {
      if (!isTmsMarketingUser()) return menu

      const allowedTopLevelMenu = new Set([
        'menuitems.dashboards.text',
        'menuitems.liveView.text',
        'menuitems.controlTower.text',
        'menuitems.notifikasi.text',
        'menuitems.laporan.text',
        'menuitems.orderManagement.text',
      ])

      const filteredMenu = menu
        .map((item) => {
          if (item.isBorder) return item
          if (!allowedTopLevelMenu.has(item.label)) return null

          if (item.label !== 'menuitems.orderManagement.text') return item

          return {
            ...item,
            subItems: (item.subItems || []).filter(
              (subItem) =>
                subItem.label === 'menuitems.delivery.text' ||
                subItem.label === 'menuitems.fleetTask.text'
            ),
          }
        })
        .filter(Boolean)

      return this.cleanMenuBorder(filteredMenu)
    },
    cleanMenuBorder(menu = []) {
      return menu.filter((item, index) => {
        if (!item.isBorder) return true

        const hasMenuBefore = menu.slice(0, index).some((entry) => !entry.isBorder)
        const hasMenuAfter = menu.slice(index + 1).some((entry) => !entry.isBorder)

        return hasMenuBefore && hasMenuAfter
      })
    },
    goToPage(item) {
      if (item?.redirectTo) {
        return item.redirectTo()
      }

      this.$router.push({ path: item.link })
    },
    isMenuShown(item) {
      if (typeof item.subItems == 'undefined') {
        return item.isHasAccess()
      }

      return item.subItems.some((subItem) => subItem.isHasAccess())
    },
    isRouteMatch(menuPath, currentPath) {
      let parsedCurrentPath = currentPath

      if (!parsedCurrentPath.endsWith('/')) {
        parsedCurrentPath = parsedCurrentPath + '/'
      }

      return parsedCurrentPath.startsWith(menuPath)
    },
  },
}
</script>

<style lang="scss" scoped>
#sidebar-menu {
  padding: 0px 12px 12px;
  position: relative;

  .mc-side-nav {
    &__horizontal-line {
      margin: 0;
    }

    &__badge {
      padding: 2px 6px;
      font-size: 10px;
      margin-left: 8px;
      height: fit-content;
    }

    &__notif-badge {
      position: absolute;
      background-color: $red;
      border-radius: 8px;
      width: 10px;
      height: 10px;
      top: 10px;
      left: 20px;

      @media (max-width: 992px) {
        left: 36px;
        top: 12px;
      }
    }

    &__menu-group {
      background-color: $white;
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    &__menu-list {
      a {
        border-radius: 4px;
        padding: 10px;
      }

      > [aria-expanded='true'] {
        color: $mep-primary !important;

        i::before {
          color: $mep-primary;
        }
      }

      &:has(.router-link-active) {
        .expanded-menu {
          color: $mep-primary;

          i::before {
            color: $mep-primary;
          }
        }
      }
    }

    &__submenu-group {
      padding-left: 20px;
      margin-top: 6px;
    }

    &__submenu-list {
      border-left: 1px solid $teal-100;

      a {
        margin-left: 12px;
        padding-left: 4px;
      }
    }

    &__list-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .label {
        color: $mep-color-text-300;
        flex: 1;
      }

      &.router-link-active {
        border-radius: 4px;
        background-color: $mep-secondary-100;

        .label,
        i::before {
          color: $mep-primary;
        }
      }
    }
  }
}
</style>
